export default __webpack_public_path__ + "static/media/gitHubPicWeb.1ae024a6.jpg";